import { useQuery } from "@apollo/client"
import { GetConnectorTypesDocument } from "@hydrologiq/gql-experience/graphql"
import { usePrimaryClientIfAvailable } from "../../providers/DualGraphQLProvider"

export const useConnectorTypes = () => {
  const client = usePrimaryClientIfAvailable()
  const { data, loading, error } = useQuery(GetConnectorTypesDocument, {
    client,
    fetchPolicy: "cache-first",
  })

  return {
    connectorTypes: data?.getConnectorTypes ?? [],
    loading,
    error,
  }
}
